import styled, { keyframes } from "styled-components";
import { primaryColor, primaryColorHover, errorColor } from "../../../../../config/constants";
import { fadeInDown } from "react-animations";
// Keyframes
const fadeInDownAnimation = keyframes`${fadeInDown}`;

export const DeleteDiv = styled.div`
  padding: 30px 15px;
  margin: auto;
  width: 100%;
  max-width: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  animation: 0.4s ${fadeInDownAnimation};
`;
export const DeleteText = styled.p`
  font-size: 14px;
  text-align: center;
`;
export const BackAndDeleteDiv = styled.div`
  margin: 15px 0 0;
  display: flex;
`;
export const BackButton = styled.button`
  margin-right: 10px;
  padding: 10px;
  width: 108px;
  height: 38px;
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background-color: ${primaryColor};
  outline: none;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
`;
export const DeleteButton = styled.button`
  padding: 10px;
  width: 108px;
  height: 38px;
  border: 1px solid ${errorColor};
  border-radius: 5px;
  color: ${errorColor};
  font-size: 14px;
  font-weight: bold;
  text-align: center;
  background: transparent;
  outline: none;
  cursor: pointer;
`;
